import {
  GET_PROJECT_BILLING_RATE_TEMPLATES,
  CREATE_PROJECT_BILLING_RATE_TEMPLATE,
  DELETE_PROJECT_BILLING_RATE_TEMPLATE,
  UPDATE_PROJECT_BILLING_RATE_TEMPLATE,
  GET_PROJECT_BILLING_RATES,
  CREATE_PROJECT_BILLING_RATES,
  DELETE_PROJECT_BILLING_RATE,
  UPDATE_PROJECT_BILLING_RATE,
} from '../../state/actionTypes';

import ProjectBillingRatesService from './projectBillingRates.service';

export const createProjectBillingRateTemplate = (payload) => async (dispatch) => {
  const res = await ProjectBillingRatesService.createTemplate(payload);
  if (res.err) {
    return {
      success: false,
      message: res.err,
    };
  }
  const { data: template } = res;

  if (!template) {
    return {
      success: false,
      message: 'Could not create project billing rate template.',
    };
  }
  
  dispatch({
    type: CREATE_PROJECT_BILLING_RATE_TEMPLATE,
    payload: {
      template,
    },
  });
  return { success: true };
};

// Return custom object with success, message, and invalidSourceTemplateIds
// (for multiple rates)
export const createProjectBillingRates = (
  projectId,
  payload,
) => async (dispatch) => {
  const res = await ProjectBillingRatesService.createProjectRates(
    projectId,
    payload,
  );
  if (res.err) {
    return {
      success: false,
      message: res.err,
      invalidSourceTemplateIds: res.errorData?.invalidSourceTemplateIds ?? [],
    };
  }
  const { data } = res;
  if (!data?.rates?.length) {
    return {
      success: false,
      message: 'Could not create billing rates.',
      invalidSourceTemplateIds: [],
    };
  }
  dispatch({
    type: CREATE_PROJECT_BILLING_RATES,
    payload: {
      projectId,
      projectRates: data.rates,
    },
  });
  return {
    success: true,
    invalidSourceTemplateIds: [],
  };
};

export const getProjectBillingRateTemplates = () => async (dispatch) => {
  const { data: templates } = await ProjectBillingRatesService.getTemplates();
  if (!templates) return false;
  dispatch({
    type: GET_PROJECT_BILLING_RATE_TEMPLATES,
    payload: {
      templates,
    },
  });
  return true;
};

export const getProjectBillingRates = (projectId) => async (dispatch) => {
  const { data: projectRates } = await ProjectBillingRatesService.getProjectRates(projectId);
  if (!projectRates) return false;
  dispatch({
    type: GET_PROJECT_BILLING_RATES,
    payload: {
      projectId,
      projectRates,
    },
  });
  return true;
};

export const updateProjectBillingRateTemplate = (id, payload) => async (dispatch) => {
  const res = await ProjectBillingRatesService.updateTemplate(id, payload);
  if (res.err) {
    return {
      success: false,
      message: res.err,
    };
  }
  const { data } = res;
  if (!data) {
    return {
      success: false,
      message: 'Could not update project billing rate template.',
    };
  }
  dispatch({
    type: UPDATE_PROJECT_BILLING_RATE_TEMPLATE,
    payload: {
      id,
      data,
    },
  });
  return { success: true };
};

// Return custom object with success, message (for one rate only)
export const updateProjectBillingRate = (
  projectId,
  id,
  payload,
) => async (dispatch) => {
  const res = await ProjectBillingRatesService.updateProjectRate(projectId, id, payload);
  if (res.err) {
    return {
      success: false,
      message: res.err,
    };
  }
  const { data } = res;
  if (!data) {
    return {
      success: false,
      message: 'Could not update billing rate.',
    };
  }
  dispatch({
    type: UPDATE_PROJECT_BILLING_RATE,
    payload: {
      projectId,
      id,
      data,
    },
  });
  return {
    success: true,
  };
};

export const deleteProjectBillingRateTemplate = (id) => async (dispatch) => {
  const { data } = await ProjectBillingRatesService.deleteTemplate(id);
  if (!data) return false;
  dispatch({
    type: DELETE_PROJECT_BILLING_RATE_TEMPLATE,
    payload: {
      id,
    },
  });
  return true;
};

export const deleteProjectBillingRate = (projectId, id) => async (dispatch) => {
  const { data } = await ProjectBillingRatesService.deleteProjectRate(projectId, id);
  if (!data) return false;
  dispatch({
    type: DELETE_PROJECT_BILLING_RATE,
    payload: {
      projectId,
      id,
    },
  });
  return true;
};